import { useQuery } from '@tanstack/react-query'
import { apiGet, type Health } from '../lib/api'

interface HealthIndicatorProps {
  variant: 'topbar' | 'sidebar'
}

/**
 * Zeigt den Zustand der Zentrale. In der Kopfzeile als Punkt mit Text, in der
 * Fußzeile der Navigation als Versionszeile. Status nie nur über Farbe.
 */
export function HealthIndicator({ variant }: HealthIndicatorProps) {
  const { data, isPending, isError } = useQuery({
    queryKey: ['health'],
    queryFn: ({ signal }) => apiGet<Health>('/health', signal),
    refetchInterval: 30_000,
    retry: 1,
  })

  if (variant === 'sidebar') {
    if (isPending) return <span>Zentrale: wird geprüft …</span>
    if (isError || !data) return <span>Zentrale: nicht erreichbar</span>
    return (
      <span>
        Zentrale {data.version} · Schema {data.schema_version} · {data.templates} Templates
      </span>
    )
  }

  const ok = !isError && data?.status === 'ok'
  const label = isPending
    ? 'Zentrale wird geprüft'
    : ok
      ? 'Zentrale erreichbar'
      : 'Zentrale gestört'

  return (
    <span className="row" style={{ fontSize: 13, color: 'var(--muted)' }} data-testid="health">
      <span
        className="dot"
        style={{ background: isPending ? 'var(--off)' : ok ? 'var(--ok)' : 'var(--crit)' }}
      />
      {label}
    </span>
  )
}
